import React, { useContext } from "react";
import { LocalizationContext } from "../contexts/localization-context";
import { ArtsContext } from "../contexts/arts-context";
import { voteArt, undoVoteArt } from "../services/artContestAppService";
import { setCookie, deleteCookie } from "../helpers/cookiesHelpers";

const ArtVoteButton = ({ artId, votedArtId, setVotedArtId, className, campaignName }) => {
    const [localizationState] = useContext(LocalizationContext);
    const [arts, dispatchToArts] = useContext(ArtsContext);
    const voteIsEnabled = document.getElementById("votingEnabled").value === "True" ? true : false;

    const handleVote = async (e) => {
        e.stopPropagation();
        if (votedArtId === artId) {
            const res = await undoVoteArt(campaignName, artId);
            if (!res.success) return;
            dispatchToArts({
                type: "REMOVE_VOTE",
                payload: { artId: artId, votes: res.votes },
            });
            setVotedArtId(null);
            deleteCookie("StreetArtVote");
        } else {
            const res = await voteArt(campaignName, artId);
            if (!res.success) return;
            dispatchToArts({
                type: "ADD_VOTE",
                payload: { artId: artId, votes: res.votes },
            });
            setVotedArtId(artId);
            setCookie("StreetArtVote", artId, 90);
        }
    };

    return (
        <>
            {voteIsEnabled && (votedArtId === null || votedArtId === artId) && (
                <div className={className}>
                    <button
                        className={`btn btn--vote btn--primary ${
                            votedArtId === artId ? "btn--primary-active " : ""
                        }btn--small whitespace-no-wrap`}
                        onClick={(e) => handleVote(e)}
                    >
                        {votedArtId === artId
                            ? localizationState.undoVote
                            : localizationState.voteNow}
                    </button>
                </div>
            )}
        </>
    );
};

export default ArtVoteButton;
